export default __webpack_public_path__ + "static/media/KE.37d4b183.svg";